module.exports = __webpack_public_path__ + "img/img41.e4d8db79.svg";